import { SegmentoSimulacao } from "#/enums";

const MOCK_SEGURO_TOTAL = {
  tipo: "COBERTURA",
  codigo: "modalidade",
  descricao: "Seguro total",
};

const MOCK_ASSISTENCIAS_BASICA = [
  "Reboque ou recolha de veículo após sinistro até 300km",
  "Socorro ou reboque após pane até 200km",
  "Chaveiro",
  "Falta de combustível (pane seca)",
  "Guarda de veículo",
  "Troca de pneus",
  "Meio de transporte alternativo para retorno ao domicílio ou continuação da viagem",
];

const MOCK_ASSISTENCIAS_INTERMEDIARIO = [
  ...MOCK_ASSISTENCIAS_BASICA,
  "Hospedagem",
  "Transporte para recuperação de veículo",
  "Remoção inter-hospitalar",
  "Envio de familiar",
  "Hospedagem de familiar",
  "Envio de motorista/condutor",
  "Translado de corpo",
  "Intervenção médica",
];

const MOCK_ASSISTENCIAS_BASICA_YELUM = [
  ...MOCK_ASSISTENCIAS_INTERMEDIARIO,
  "Içamento",
];

const MOCK_ASSISTENCIAS_INTERMEDIARIO_ALIRO = [
  ...MOCK_ASSISTENCIAS_INTERMEDIARIO,
  "Regresso antecipado em caso de falecimento de parentes",
];

const MOCK_ASSISTENCIAS_INTERMEDIARIO_YELUM = [
  ...MOCK_ASSISTENCIAS_BASICA_YELUM,
  "Regresso antecipado em caso de falecimento de parentes",
  "Acompanhamento médico domiciliar",
  "Apoio para retorno ao domicílio",
  "Motorista reserva",
];

const MOCK_ASSISTENCIAS_AVANCADO_YELUM = [
  ...MOCK_ASSISTENCIAS_INTERMEDIARIO_YELUM,
  "Acompanhamento de menores",
  "Leva e traz",
  "Carro reserva em caso de pane",
];

const MOCK_OFERTAS_BASICO_INCLUSO = [
  "Guincho até 300km",
  "Socorro mecânico e chaveiro",
  "Auxilio para falta de combustível",
  "Troca de pneus",
];

const MOCK_OFERTAS_BASICO_NAO_INCLUSO = [
  "Pequenos reparos",
  "Despesas de higienização",
];

const MOCK_VIDROS_BASICO = [
  "Farol/lanterna",
  "Retrovisor completo",
  "Lente de retrovisor",
];

const MOCK_VIDROS_BASICO_YELUM = [
  "Para-brisa, vigia e lateral",
  ...MOCK_VIDROS_BASICO,
  "Reparo de para-brisa",
  "Iluminação auxiliar",
  "Máquina de vidro",
  "Teto solar (quando aplicável)",
  "Para-choque",
];

const MOCK_VIDROS_INTERMEDIARIO_YELUM = [
  ...MOCK_VIDROS_BASICO_YELUM,
  "SRA - Serviço de reparo em arranhões superficiais",
  "SRA Plus - Martelinho de ouro",
];

const MOCK_VIDROS_INTERMEDIARIO_ALIRO = [
  "Para-brisa, vigia e lateral",
  "Película de proteção solar",
  "Palheta",
  ...MOCK_VIDROS_BASICO,
];

const MOCK_VIDROS_DIF_ALIRO = ["Película de proteção solar", "Palheta"];
const MOCK_VIDROS_DIF_YELUM = [
  "Reparo de para-brisa",
  "Iluminação auxiliar",
  "Máquina de vidro",
  "Teto solar (quando aplicável)",
  "Para-choque",
  "SRA - Serviço de reparo em arranhões superficiais",
  "SRA Plus - Martelinho de ouro",
];

const MOCK_ASSISTENCIAS_DIF_ALIRO = [
  "Içamento",
  "Acompanhamento médico domiciliar",
  "Apoio para retorno ao domicílio",
  "Motorista reserva",
  "Acompanhamento de menores",
  "Leva e traz",
  "Carro reserva em caso de pane",
];

const MOCK_PAGAMENTO_YELUM_BASICO = [
  {
    quantidade: 1,
    valor: "R$ 3.530,74",
    juros: false,
  },
  {
    quantidade: 2,
    valor: "R$ 1.000,00",
    juros: false,
  },
  {
    quantidade: 3,
    valor: "R$ 666,66",
    juros: false,
  },
  {
    quantidade: 4,
    valor: "R$ 500,00",
    juros: false,
  },
  {
    quantidade: 5,
    valor: "R$ 400,00",
    juros: false,
  },
  {
    quantidade: 6,
    valor: "R$ 588,45",
    juros: false,
  },
];

const MOCK_PAGAMENTO_ALIRO_BASICO = [
  {
    quantidade: 1,
    valor: "R$ 2.290,91",
    juros: false,
  },
  {
    quantidade: 2,
    valor: "R$ 1.000,00",
    juros: false,
  },
  {
    quantidade: 3,
    valor: "R$ 666,66",
    juros: false,
  },
  {
    quantidade: 4,
    valor: "R$ 500,00",
    juros: false,
  },
  {
    quantidade: 5,
    valor: "R$ 400,00",
    juros: false,
  },
  {
    quantidade: 6,
    premio: "R$ 2.000,00",
    valor: "R$ 333,33",
    juros: false,
  },
  {
    quantidade: 7,
    valor: "R$ 285,71",
    juros: false,
  },
  {
    quantidade: 8,
    valor: "R$ 250,00",
    juros: false,
  },
  {
    quantidade: 9,
    valor: "R$ 222,22",
    juros: false,
  },
  {
    quantidade: 10,
    valor: "R$ 229,09",
    juros: false,
  },
];

const MOCK_PAGAMENTO_YELUM_INTERMEDIARIO = [
  {
    quantidade: 1,
    valor: "R$ 4.119,03",
    juros: false,
  },
  {
    quantidade: 2,
    valor: "R$ 1.000,00",
    juros: false,
  },
  {
    quantidade: 3,
    valor: "R$ 666,66",
    juros: false,
  },
  {
    quantidade: 4,
    valor: "R$ 500,00",
    juros: false,
  },
  {
    quantidade: 5,
    valor: "R$ 400,00",
    juros: false,
  },
  {
    quantidade: 6,
    valor: "R$ 699,83",
    juros: false,
  },
];

const MOCK_PAGAMENTO_ALIRO_INTERMEDIARIO = [
  {
    quantidade: 1,
    valor: "R$ 2.592,27",
    juros: false,
  },
  {
    quantidade: 2,
    valor: "R$ 1.000,00",
    juros: false,
  },
  {
    quantidade: 3,
    valor: "R$ 666,66",
    juros: false,
  },
  {
    quantidade: 4,
    valor: "R$ 500,00",
    juros: false,
  },
  {
    quantidade: 5,
    valor: "R$ 400,00",
    juros: false,
  },
  {
    quantidade: 6,
    premio: "R$ 2.000,00",
    valor: "R$ 333,33",
    juros: false,
  },
  {
    quantidade: 7,
    valor: "R$ 285,71",
    juros: false,
  },
  {
    quantidade: 8,
    valor: "R$ 250,00",
    juros: false,
  },
  {
    quantidade: 9,
    valor: "R$ 222,22",
    juros: false,
  },
  {
    quantidade: 10,
    valor: "R$ 259,27",
    juros: false,
  },
];

const MOCK_PAGAMENTO_YELUM_AVANCADO = [
  {
    quantidade: 1,
    valor: "R$ 4.431,29",
    juros: false,
  },
  {
    quantidade: 2,
    valor: "R$ 1.000,00",
    juros: false,
  },
  {
    quantidade: 3,
    valor: "R$ 666,66",
    juros: false,
  },
  {
    quantidade: 4,
    valor: "R$ 500,00",
    juros: false,
  },
  {
    quantidade: 5,
    valor: "R$ 400,00",
    juros: false,
  },
  {
    quantidade: 6,
    valor: "R$ 738,54",
    juros: false,
  },
];

const MOCK_PAGAMENTO_ALIRO_AVANCADO = [
  {
    quantidade: 1,
    valor: "R$ 2.731,00",
    juros: false,
  },
  {
    quantidade: 2,
    valor: "R$ 1.000,00",
    juros: false,
  },
  {
    quantidade: 3,
    valor: "R$ 666,66",
    juros: false,
  },
  {
    quantidade: 4,
    valor: "R$ 500,00",
    juros: false,
  },
  {
    quantidade: 5,
    valor: "R$ 400,00",
    juros: false,
  },
  {
    quantidade: 6,
    premio: "R$ 2.000,00",
    valor: "R$ 333,33",
    juros: false,
  },
  {
    quantidade: 7,
    valor: "R$ 285,71",
    juros: false,
  },
  {
    quantidade: 8,
    valor: "R$ 250,00",
    juros: false,
  },
  {
    quantidade: 9,
    valor: "R$ 222,22",
    juros: false,
  },
  {
    quantidade: 10,
    valor: "R$ 313,28",
    juros: false,
  },
];

export const MOCK_OFERTAS = {
  numero: "01160701202400000001",
  resposta: {
    codigo: "XXX",
    descricao: "Cobertura cobertura2 nao encontrada",
    statusHttp: 404,
  },
  ofertas: [
    {
      segmento: SegmentoSimulacao.BASICO,
      produtos: [
        {
          versao: 1,
          nome: "Yelum",
          descricao: "Yelum Affinity Auto Perfil",
          logo: "url",
          franquia: {
            descricao: "normal",
            valor: "R$ 6.282,00",
          },
          detalhes: [
            MOCK_SEGURO_TOTAL,
            {
              tipo: "COBERTURA",
              codigo: "dano_material",
              descricao: "R$ 100.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_corporal",
              descricao: "R$ 100.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_morais",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "invalidez",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "morte",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "assistencia_24h",
              descricao: "Básico",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "vidros",
              descricao: "Intermediário",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "carro_reserva",
              descricao: "Básico - 7 dias c/ ar",
            },
          ],
          opcoesPagamento: [
            {
              forma: "DEBITO_CONTA",
              parcelas: MOCK_PAGAMENTO_YELUM_BASICO,
            },
            {
              forma: "CARTAO_CREDITO",
              parcelas: MOCK_PAGAMENTO_YELUM_BASICO,
            },
          ],
          diferencial: [
            {
              tipo: "OFERTA",
              inclusos: MOCK_OFERTAS_BASICO_INCLUSO,
              naoInclusos: MOCK_OFERTAS_BASICO_NAO_INCLUSO,
            },
            {
              tipo: "ASSISTENCIA",
              inclusos: MOCK_ASSISTENCIAS_BASICA_YELUM,
              naoInclusos: [
                "Regresso antecipado em caso de falecimento de parentes",
                "Acompanhamento médico domiciliar",
                "Apoio para retorno ao domicílio",
                "Motorista reserva",
                "Acompanhamento de menores",
                "Leva e traz",
                "Carro reserva em caso de pane",
              ],
            },
            {
              tipo: "VIDROS",
              inclusos: MOCK_VIDROS_BASICO_YELUM,
              naoInclusos: [
                "SRA - Serviço de reparo em arranhões superficiais",
                "SRA Plus - Martelinho de ouro",
              ],
              disponivelEmOutro: [
                {
                  nome: "Aliro Seguro",
                  itens: MOCK_VIDROS_DIF_ALIRO,
                },
              ],
            },
          ],
        },
        {
          versao: 2,
          nome: "Aliro",
          descricao: "Aliro Seguros",
          logo: "url",
          franquia: {
            descricao: "normal",
            valor: "R$ 6.282,00",
          },
          detalhes: [
            MOCK_SEGURO_TOTAL,
            {
              tipo: "COBERTURA",
              codigo: "dano_material",
              descricao: "R$ 50.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_corporal",
              descricao: "R$ 50.000,00",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "assistencia_24h",
              descricao: "Básico",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "vidros",
              descricao: "Básico",
            },
          ],
          opcoesPagamento: [
            {
              forma: "DEBITO_CONTA",
              parcelas: MOCK_PAGAMENTO_ALIRO_BASICO,
            },
            {
              forma: "CARTAO_CREDITO",
              parcelas: MOCK_PAGAMENTO_ALIRO_BASICO,
            },
          ],
          diferencial: [
            {
              tipo: "OFERTA",
              inclusos: MOCK_OFERTAS_BASICO_INCLUSO,
              naoInclusos: [
                "Carro reserva",
                ...MOCK_OFERTAS_BASICO_NAO_INCLUSO,
              ],
            },
            {
              tipo: "ASSISTENCIA",
              inclusos: MOCK_ASSISTENCIAS_BASICA,
              naoInclusos: [
                "Hospedagem",
                "Transporte para recuperação de veículo",
                "Remoção inter-hospitalar",
                "Envio de familiar",
                "Hospedagem de familiar",
                "Envio de motorista/condutor",
                "Translado de corpo",
                "Intervenção médica",
              ],
              disponivelEmOutro: [
                {
                  nome: "Yelum Seguradora",
                  itens: MOCK_ASSISTENCIAS_DIF_ALIRO,
                },
              ],
            },
            {
              tipo: "VIDROS",
              inclusos: [
                "Para-brisa, vigia e lateral",
                "Película de proteção solar",
                "Palheta",
              ],
              naoInclusos: MOCK_VIDROS_BASICO,
              disponivelEmOutro: [
                {
                  nome: "Yelum Seguradora",
                  itens: MOCK_VIDROS_DIF_YELUM,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      segmento: SegmentoSimulacao.INTERMEDIARIO,
      produtos: [
        {
          versao: 3,
          nome: "Yelum",
          descricao: "Yelum Affinity Auto Perfil",
          logo: "url",
          franquia: {
            descricao: "reduzida",
            valor: "R$ 2.731,00",
          },
          detalhes: [
            MOCK_SEGURO_TOTAL,
            {
              tipo: "COBERTURA",
              codigo: "dano_material",
              descricao: "R$ 150.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_corporal",
              descricao: "R$ 150.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_morais",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "invalidez",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "morte",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "assistencia_24h",
              descricao: "Intermediário",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "vidros",
              descricao: "Avançado",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "carro_reserva",
              descricao: "Básico - 15 dias c/ ar",
            },
          ],
          opcoesPagamento: [
            {
              forma: "DEBITO_CONTA",
              parcelas: MOCK_PAGAMENTO_YELUM_INTERMEDIARIO,
            },
            {
              forma: "CARTAO_CREDITO",
              parcelas: MOCK_PAGAMENTO_YELUM_INTERMEDIARIO,
            },
          ],
          diferencial: [
            {
              tipo: "OFERTA",
              inclusos: [
                "Guincho até 300km",
                "Socorro mecânico e chaveiro",
                "Auxilio para falta de combustível",
                "Troca de pneus",
              ],
              naoInclusos: ["Pequenos reparos", "Despesas de higienização"],
            },
            {
              tipo: "ASSISTENCIA",
              inclusos: MOCK_ASSISTENCIAS_INTERMEDIARIO_YELUM,
              naoInclusos: [
                "Acompanhamento de menores",
                "Leva e traz",
                "Carro reserva em caso de pane",
              ],
            },
            {
              tipo: "VIDROS",
              inclusos: MOCK_VIDROS_INTERMEDIARIO_YELUM,
              disponivelEmOutro: [
                {
                  nome: "Aliro Seguro",
                  itens: MOCK_VIDROS_DIF_ALIRO,
                },
              ],
            },
          ],
        },
        {
          versao: 4,
          nome: "Aliro",
          descricao: "Aliro Seguros",
          logo: "url",
          franquia: {
            descricao: "normal",
            valor: "R$ 6.282,00",
          },
          detalhes: [
            MOCK_SEGURO_TOTAL,
            {
              tipo: "COBERTURA",
              codigo: "dano_material",
              descricao: "R$ 100.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_corporal",
              descricao: "R$ 100.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_morais",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "invalidez",
              descricao: "R$ 5.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "morte",
              descricao: "R$ 5.000,00",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "assistencia_24h",
              descricao: "Avançado",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "vidros",
              descricao: "Intermediário",
            },
          ],
          opcoesPagamento: [
            {
              forma: "DEBITO_CONTA",
              parcelas: MOCK_PAGAMENTO_ALIRO_INTERMEDIARIO,
            },
            {
              forma: "CARTAO_CREDITO",
              parcelas: MOCK_PAGAMENTO_ALIRO_INTERMEDIARIO,
            },
          ],
          diferencial: [
            {
              tipo: "OFERTA",
              inclusos: [
                "Guincho até 500km",
                "Socorro mecânico e chaveiro",
                "Auxilio para falta de combustível",
                "Troca de pneus",
              ],
              naoInclusos: [
                "Carro reserva",
                "Pequenos reparos",
                "Despesas de higienização",
              ],
            },
            {
              tipo: "ASSISTENCIA",
              inclusos: MOCK_ASSISTENCIAS_INTERMEDIARIO_ALIRO,
              disponivelEmOutro: [
                {
                  nome: "Yelum Seguradora",
                  itens: MOCK_ASSISTENCIAS_DIF_ALIRO,
                },
              ],
            },
            {
              tipo: "VIDROS",
              inclusos: MOCK_VIDROS_INTERMEDIARIO_ALIRO,
              disponivelEmOutro: [
                {
                  nome: "Yelum Seguradora",
                  itens: MOCK_VIDROS_DIF_YELUM,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      segmento: SegmentoSimulacao.AVANCADO,
      produtos: [
        {
          versao: 5,
          nome: "Yelum",
          descricao: "Yelum Affinity Auto Perfil",
          logo: "url",
          franquia: {
            descricao: "reduzida",
            valor: "R$ 2.731,00",
          },
          detalhes: [
            {
              tipo: "COBERTURA",
              codigo: "modalidade",
              descricao: "Seguro total",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_material",
              descricao: "R$ 200.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_corporal",
              descricao: "R$ 200.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_morais",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "invalidez",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "morte",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "assistencia_24h",
              descricao: "Avançado",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "vidros",
              descricao: "Avançado",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "carro_reserva",
              descricao: "Básico - 35 dias c/ ar",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "pequenos_reparos",
              descricao: "Incluso",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "despesas_higienização",
              descricao: "Incluso",
            },
          ],
          opcoesPagamento: [
            {
              forma: "DEBITO_CONTA",
              parcelas: MOCK_PAGAMENTO_YELUM_AVANCADO,
            },
            {
              forma: "CARTAO_CREDITO",
              parcelas: MOCK_PAGAMENTO_YELUM_AVANCADO,
            },
          ],
          diferencial: [
            {
              tipo: "OFERTA",
              inclusos: [
                "Guincho sem limite",
                "Socorro mecânico e chaveiro",
                "Auxilio para falta de combustível",
                "Troca de pneus",
              ],
              naoInclusos: ["Garantia 0km", "Extensão de perímetro"],
            },
            {
              tipo: "ASSISTENCIA",
              inclusos: MOCK_ASSISTENCIAS_AVANCADO_YELUM,
            },
            {
              tipo: "VIDROS",
              inclusos: MOCK_VIDROS_INTERMEDIARIO_YELUM,
              disponivelEmOutro: [
                {
                  nome: "Aliro Seguro",
                  itens: MOCK_VIDROS_DIF_ALIRO,
                },
              ],
            },
          ],
        },
        {
          versao: 6,
          nome: "Aliro",
          descricao: "Aliro Seguros",
          logo: "url",
          franquia: {
            descricao: "reduzida",
            valor: "R$ 2.731,00",
          },
          detalhes: [
            MOCK_SEGURO_TOTAL,
            {
              tipo: "COBERTURA",
              codigo: "dano_material",
              descricao: "R$ 150.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_corporal",
              descricao: "R$ 150.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "dano_morais",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "invalidez",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "COBERTURA",
              codigo: "morte",
              descricao: "R$ 10.000,00",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "assistencia_24h",
              descricao: "Avançado",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "vidros",
              descricao: "Intermediário",
            },
            {
              tipo: "ASSISTENCIA",
              codigo: "carro_reserva",
              descricao: "7 dias c/ ar ou desc. fran.",
            },
          ],
          opcoesPagamento: [
            {
              forma: "DEBITO_CONTA",
              parcelas: MOCK_PAGAMENTO_ALIRO_AVANCADO,
            },
            {
              forma: "CARTAO_CREDITO",
              parcelas: MOCK_PAGAMENTO_ALIRO_AVANCADO,
            },
          ],
          diferencial: [
            {
              tipo: "OFERTA",
              inclusos: [
                "Guincho até 500km",
                "Socorro mecânico e chaveiro",
                "Auxilio para falta de combustível",
                "Troca de pneus",
              ],
              naoInclusos: ["Pequenos reparos", "Despesas de higienização"],
            },
            {
              tipo: "ASSISTENCIA",
              inclusos: MOCK_ASSISTENCIAS_INTERMEDIARIO_ALIRO,
              disponivelEmOutro: [
                {
                  nome: "Yelum Seguradora",
                  itens: MOCK_ASSISTENCIAS_DIF_ALIRO,
                },
              ],
            },
            {
              tipo: "VIDROS",
              inclusos: MOCK_VIDROS_INTERMEDIARIO_ALIRO,
              disponivelEmOutro: [
                {
                  nome: "Yelum Seguradora",
                  itens: MOCK_VIDROS_DIF_YELUM,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
